import {useDNDContext} from '../Table/DNDController/useDNDContext';
import {MutableRefObject, useEffect, useRef} from 'react';

const EVENT_HANDLER_HEIGHT = 50;
const SCROLL_VALUE_PER_TICK = 20;
const SCROLL_TICK_INTERVAL = 100;

enum ScrollDirection {
    Unset,
    Top,
    Bottom
}

export const useScrollWrapper = (scrollbarRef: MutableRefObject<any>) => {
    const dndState = useDNDContext();
    const scrollInterval = useRef<NodeJS.Timeout>();
    const currentScrollDirection = useRef<ScrollDirection>(ScrollDirection.Unset);

    useEffect(() => {
        if (dndState && dndState.isMoving) {
            const scrollCallback = () => {
                const scrollObj = scrollbarRef.current as any;
                const scrollTopValue = scrollObj.getScrollTop() as number;

                if (currentScrollDirection.current === ScrollDirection.Top) {
                    scrollObj.scrollTop(scrollTopValue - SCROLL_VALUE_PER_TICK);
                } else {
                    scrollObj.scrollTop(scrollTopValue + SCROLL_VALUE_PER_TICK);
                }
            };

            const mouseMoveHandler = (event: MouseEvent) => {
                const scrollObj = scrollbarRef.current as any;
                const wrapperRect = (scrollObj.container as HTMLDivElement).getBoundingClientRect();

                // check if it is in the wrapper
                if (
                    wrapperRect.top <= event.pageY &&
                    wrapperRect.bottom >= event.pageY &&
                    wrapperRect.left <= event.pageX &&
                    wrapperRect.right >= event.pageX
                ) {
                    // check if it is bottom
                    if (wrapperRect.bottom - event.pageY <= EVENT_HANDLER_HEIGHT) {
                        if (currentScrollDirection.current !== ScrollDirection.Bottom) {
                            if (scrollInterval.current) {
                                clearInterval(scrollInterval.current);
                                scrollInterval.current = undefined;
                            }
                            currentScrollDirection.current = ScrollDirection.Bottom;
                            scrollInterval.current = setInterval(
                                scrollCallback,
                                SCROLL_TICK_INTERVAL
                            );
                        }
                    }
                    // check if it is top
                    else if (event.pageY - wrapperRect.top <= EVENT_HANDLER_HEIGHT) {
                        if (currentScrollDirection.current !== ScrollDirection.Top) {
                            if (scrollInterval.current) {
                                clearInterval(scrollInterval.current);
                                scrollInterval.current = undefined;
                            }
                            currentScrollDirection.current = ScrollDirection.Top;
                            scrollInterval.current = setInterval(
                                scrollCallback,
                                SCROLL_TICK_INTERVAL
                            );
                        }
                    } else {
                        if (currentScrollDirection.current !== ScrollDirection.Unset) {
                            currentScrollDirection.current = ScrollDirection.Unset;
                            clearInterval(scrollInterval.current);
                            scrollInterval.current = undefined;
                        }
                    }
                } else if (currentScrollDirection.current !== ScrollDirection.Unset) {
                    currentScrollDirection.current = ScrollDirection.Unset;
                    clearInterval(scrollInterval.current);
                    scrollInterval.current = undefined;
                }
            };

            document.body.addEventListener('mousemove', mouseMoveHandler);

            return () => {
                document.body.removeEventListener('mousemove', mouseMoveHandler);

                if (currentScrollDirection.current !== ScrollDirection.Unset) {
                    currentScrollDirection.current = ScrollDirection.Unset;
                    clearInterval(scrollInterval.current);
                    scrollInterval.current = undefined;
                }
            };
        }
        return () => {};
    }, [dndState?.isMoving]);
};
